export * from './status-log-geral.pipe';
